module.exports = __webpack_public_path__ + "img/solar-ie-background.16f01f96.jpg";